<template>
  <div class="error-404">
    <div class="container">
      <div class="container_1"><img :src="$ebConfig.imgPath+'img/404/404.png'"></div>
      <div class="container_2"><img :src="$ebConfig.imgPath+'img/404/3.22.gif'"></div>
      <div class="container_3">
        <div class="container_3_1">
          <span>SORRY你要访问的页面弄丢了</span>
        </div>
        <div class="container_3_2">
          <span>你可以通过以下方式重新访问......</span>
        </div>
      </div>
    </div>
    <div class="maincolumn">
      <div class="maincolumn_bg">
        <ul>
          <li>
            <a href="/aboutebid/aboutUs">关于我们</a>
          </li>
          <li>
            <a href="/aboutebid/contactUs">联系我们</a>
          </li>
          <li>
            <a href="/aboutebid/merchantEntry">商家入驻</a>
          </li>
          <li>
            <a href="/portal">返回首页</a>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>
<script>
import $ from 'jquery';
export default {
  name: 'error404',
  created() {
    this.$root.layout.isShowAside = false;
    this.$root.layout.isShowTop = false;
    this.$root.layout.isShowNav = false;
    this.$root.layout.isShowHeader = false;
    this.$root.layout.isShowBottom = false;
    this.$root.layout.isLoading = false;
    this.$root.layout.isBackground = false;
  },
  mounted() {
    $('#app').css({
      height: '100%',
      'min-width': '1366px'
    });
    $('.container_main').css({
      width: '100%',
      margin: 0,
      'min-width': '1366px'
    });
    $('html').css({
      height: '100%',
      'min-width': '1366px'
    });
    $('body').css({
      height: '100%',
      'min-width': '1366px'
    });
    $('.container_box').css({
      height: '100%',
      'min-width': '1366px'
    });
    $('.container_main').css({
      height: '100%',
      'min-width': '1366px'
    });
    $('.container_main_body').css({
      height: '100%',
      'min-width': '1366px'
    });
  }
};
</script>
<style lang="less">
.error-404 {
  width: 100%;
  height: 100%;
  background-image: url(../../assets/img/404/bg.jpg);
  background-position: 40% 0px;
  font-family: 'Microsoft YaHei';
  font-weight: 700;
  font: normal 100% Helvetica, Arial, sans-serif 900;
  a {
    text-decoration: none;
  }
  a:link {
    color: #fff;
    text-decoration: none;
    text-decoration: none;
  }
  a:visited {
    color: #fff;
    text-decoration: none;
  }
  a:hover {
    color: #fff;
    text-decoration: none;
  }
  .container {
    margin-left: auto;
    width: 100%;
    margin-right: auto;
    text-align: center;
    margin-top: 100px;
  }
  .container_1 img {
    margin-top: 5%;
    width: 250px;
    height: 120px;
  }
  .container_2 img {
    margin-top: -2%;
  }
  .container_3 img {
    width: 25%;
    height: 7.5%;
  }
  .container_3 {
    width: 28vw;
    margin: auto;
  }
  .container_3_1 {
    color: #6bbaa3;
    font-size: 2vw;
    text-align: left;
  }
  .container_3_2 {
    color: #6bbaa3;
    font-size: 1vw;
    text-align: left;
  }
  .maincolumn {
    margin-left: auto;
    width: 100%;
    margin-right: auto;
    text-align: center;
    display: block;
    margin-top: 10px;
  }
  .maincolumn .maincolumn_bg {
    width: 28%;
    height: 50px;
    line-height: 50px;
    background-color: #6bbaa3;
    margin: auto;
  }
  .maincolumn .maincolumn_bg ul {
    list-style-type: none;
    -webkit-padding-start: 0px;
  }
  .maincolumn .maincolumn_bg ul li {
    float: left;
    width: 25%;
  }
  .maincolumn .maincolumn_bg ul li a {
    font-size: 18px;
  }
  .maincolumn .maincolumn_bg ul li a:hover {
    width: 100%;
    height: 50px;
    background-color: #47997d;
    display: block;
  }
}
</style>
